import { useMemo } from "react";
import { useSearchParamState } from "use-search-param-state";
import type { Tag } from "../eCommerce2/filter/TagFiltersMenu";
import { useSearchParamArray } from "./filter/useSearchParamArray";
import { useTagParams } from "./filter/useTagParams";

const REGIONS_KEY = "region";
const NAME_KEY = "name";

export interface PublicPackagesSearchCriteria {
  readonly tags: Tag[];
  readonly regions: string[];
  readonly name: string;
}

export const usePublicPackagesSearch = () => {
  const { tags } = useTagParams();
  const [regions] = useSearchParamArray(REGIONS_KEY);
  const [rawName] = useSearchParamState(NAME_KEY, "");
  const name = String(rawName ?? "").toLocaleLowerCase();

  const searchCriteria = useMemo(
    () => ({
      tags,
      regions,
      name,
    }),
    [tags, regions, name],
  );

  return { searchCriteria };
};
